var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-tile-action',[(_vm.seen_at == null)?_c('v-icon',{attrs:{"color":"#211850"}},[_vm._v("pending")]):_c('v-icon',{attrs:{"color":"#638d37"}},[_vm._v("done_all")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }